<script setup>
import { ref, defineProps, computed } from "vue"
import { XMarkIcon } from "@heroicons/vue/20/solid"
import SignInForm from "@/js/partials/signin/InputForm.vue"
import SignUpForm from "@/js/partials/signup/Installer.vue"
import Modal from "@common/js/utils/Modal.vue"
import Success from "@/js/partials/signup/EmailSent.vue"
const form = ref({
  installer: {},
})
const success = ref(false)
const props = defineProps(["modelValue"])
const emit = defineEmits(["update:modelValue"])
const dialog = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    return emit("update:modelValue", value)
  },
})
</script>
<template>
  <Modal
    v-model="dialog.toggle"
    :size="success ? 'max-w-4xl' : 'max-w-xl'"
    @close="dialog.toggle = false"
  >
    <div class="flex">
      <XMarkIcon class="w-5 cursor-pointer" @click="dialog.toggle = false" />
      <p class="text-lg mx-auto block font-semibold">
        {{ $t(`common.${dialog.mode}`) }}
      </p>
    </div>
    <hr class="mt-2 mb-7" />
    <div v-if="!success">
      <div v-if="dialog.mode == 'sign-up'">
        <SignUpForm v-model="form" @success="success = true" />
        <div class="grid grid-cols-[35%_30%_35%] items-center my-5">
          <hr />
          <p class="text-center text-xs">Déjà un compte ?</p>
          <hr />
        </div>
        <button
          type="button"
          class="w-full rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm"
          @click="dialog.mode = 'sign-in'"
        >
          S'identifier
        </button>
      </div>
      <div v-else>
        <SignInForm
          v-model="form"
          default-type="installer"
          @success="success = true"
        />
        <div class="grid grid-cols-[35%_30%_35%] items-center my-5">
          <hr />
          <p class="text-center text-xs">Pas de compte ?</p>
          <hr />
        </div>
        <button
          type="button"
          class="w-full rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm"
          @click="dialog.mode = 'sign-up'"
        >
          Créer un compte
        </button>
      </div>
    </div>
    <Success v-else />
  </Modal>
</template>
